import AppConfig from './DataAppConfig';

const ModeratorManagementAppConfig = [AppConfig];

export default ModeratorManagementAppConfig;
